import React, { useEffect, useState } from "react";
import Constants from "expo-constants";

import * as AppleAuthentication from "expo-apple-authentication";
import {
  View,
  StyleSheet,
  Modal,
  TouchableOpacity,
  Alert,
  Platform,
  Image} from "react-native";
import * as WebBrowser from "expo-web-browser";
import * as AuthSession from "expo-auth-session";
import * as Linking from "expo-linking";
import FontAwesome from '@expo/vector-icons/FontAwesome';
import { fonts } from "../styles/theme";
import AppText from "./AppText";

WebBrowser.maybeCompleteAuthSession();

type AppleAuthProps = {
  onLoginSuccess?: (credential: any) => void;
};

const AppleAuth: React.FC<AppleAuthProps> = ({ onLoginSuccess }) => {
  const api_url = Constants.expoConfig?.extra?.API_URL;

  const [showModal, setShowModal] = useState(false);
  const clientId = "com.epicestates.sid"; // Service ID from Apple Developer portal

  const discovery = {
    authorizationEndpoint: "https://appleid.apple.com/auth/authorize",
    tokenEndpoint: "https://appleid.apple.com/auth/token"};

  const redirectUri = `${api_url}portal/auth/callback`;
  const appleConfig: AuthSession.AuthRequestConfig = {
    clientId,
    redirectUri,
    responseType: "code",
    scopes: ["name", "email"],
    extraParams: {
      response_mode: "form_post",
      platform: Platform.OS}};

  const [request, response, promptAsync] = AuthSession.useAuthRequest(
    appleConfig,
    discovery
  );

  useEffect(() => {
    console.log("Apple Auth Response:>>>>>>>>>!!!!!!", response);
    handleAppleResponse();
  }, [response]);

  const handleAppleResponse = async () => {
    console.log("Handling Apple Auth Response:", response);
    if (response?.type === "success") {
      const { code } = response.params;
      onLoginSuccess?.(code);
    } else if (response?.type === "error") {
      console.error("Apple Sign In Error:", response.params);
    }
  };

  const handleAppleLoginIOS = async () => {
    try {
      console.log("Starting Apple Sign In for iOS");
      const credential = await AppleAuthentication.signInAsync({
        requestedScopes: [
          AppleAuthentication.AppleAuthenticationScope.FULL_NAME,
          AppleAuthentication.AppleAuthenticationScope.EMAIL,
        ]});

      if (credential.email) {
        Alert.alert(
          "Confirm Login",
          `You're signing in with:\n${credential.email}`,
          [
            { text: "Cancel", style: "cancel" },
            { text: "Continue", onPress: () => onLoginSuccess?.(credential) },
          ]
        );
      } else {
        onLoginSuccess?.(credential);
      }
    } catch (e: any) {
      if (e.code === "ERR_CANCELED") {
        console.log("User canceled Apple Sign In");
      } else {
        console.error("Apple Sign In Error:", e);
      }
    }
  };

  const handleAppleLoginWeb = async () => {
    try {
      const params = new URLSearchParams({
        response_type: "code",
        response_mode: "form_post",
        client_id: clientId,
        redirect_uri: redirectUri,
        scope: "name email"});

      const authUrl = `${discovery.authorizationEndpoint}?${params.toString()}`;
      window.location.href = authUrl;
    } catch (e) {
      console.error("Failed to start Apple web auth:", e);
    }
  };

  const handleAppleLoginAndroid = async () => {
    console.log(
      "Starting Apple login for Android????????????????????@@@@@@@@@@"
    );
    // First, set up a listener for the deep link
    const subscription = Linking.addEventListener("url", (event) => {
      const url = event.url;
      if (url && url.startsWith("epicportal://apple-callback")) {
        console.log("Received deep link for Apple Android callback:", url);
        // Parse the data from the deep link
        if (url.includes("#")) {
          const fragment = url.split("#")[1];
          const params = new URLSearchParams(fragment);
          console.log(
            "Parsed URL fragment for Apple Android callback:",
            params.toString()
          );
          const appleId = params.get("appleId");
          const email = params.get("email");
          const firstName = params.get("firstName");
          const lastName = params.get("lastName");
          const identityToken = params.get("identityToken");

          console.log("Apple Android callback received????????????:", {
            appleId,
            email,
            firstName,
            lastName,
            identityToken});
          if (appleId && email && identityToken) {
            onLoginSuccess?.({
              appleId,
              email,
              identityToken,
              firstName,
              lastName});
          }
        }

        // Remove the listener
        subscription.remove();
      }
    });

    // Now open the Apple auth URL
    const params = new URLSearchParams({
      response_type: "code",
      response_mode: "form_post",
      client_id: clientId,
      redirect_uri: `${api_url}portal/auth/callback`, // Your backend callback
      state: "platform:android",
      scope: "name email"});

    const authUrl = `https://appleid.apple.com/auth/authorize?${params.toString()}`;
    // Use Linking.openURL instead of WebBrowser
    Linking.openURL(authUrl);
    console.log("Opened Apple auth URL for Android:", authUrl);
  };

  const handleContinue = () => {
    setShowModal(false);
    if (Platform.OS === "ios") handleAppleLoginIOS();
    else if (Platform.OS === "android") handleAppleLoginAndroid();
    else handleAppleLoginWeb();
  };

  return (
    <View style={styles.container}>
      {Platform.OS === "ios" ? (
        <AppleAuthentication.AppleAuthenticationButton
          buttonType={AppleAuthentication.AppleAuthenticationButtonType.SIGN_IN}
          buttonStyle={AppleAuthentication.AppleAuthenticationButtonStyle.BLACK}
          cornerRadius={8}
          style={styles.button}
          onPress={() => setShowModal(true)}
        />
      ) : (
        <TouchableOpacity
          onPress={() => setShowModal(true)}
          style={styles.webButton}
        >
          <View style={{flexDirection: "row", alignItems: "center", backgroundColor: "#000"}}>
           <FontAwesome style={{paddingRight: 10}} name="apple" size={24} color="white" />
            <AppText style={styles.webButtonText}>Sign in with Apple</AppText>
          </View>
        </TouchableOpacity>
      )}

      {/* Info Modal */}
      <Modal
        transparent
        visible={showModal}
        animationType="fade"
        onRequestClose={() => setShowModal(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <AppText style={styles.modalTitle}>Important Notice</AppText>
            <AppText style={styles.modalText}>
              Ensure your Apple and Google Sign-In emails are the same for
              account access. Also, grant access to your Apple ID email.
            </AppText>

            <View style={styles.modalButtons}>
              <TouchableOpacity
                style={styles.cancelBtn}
                onPress={() => setShowModal(false)}
              >
                <AppText style={styles.cancelText}>Cancel</AppText>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.continueBtn}
                onPress={handleContinue}
                // For web we don't depend on the local `request` from
                // expo-auth-session because we redirect to the backend.
                disabled={Platform.OS !== "web" && !request}
              >
                <AppText style={styles.continueText}>Continue</AppText>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

export default AppleAuth;

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    marginTop: 25},
  button: {
    width: 390,
    height: 66},
  webButton: {
    backgroundColor: "#000",
    width: 390,
    height: 66,
    borderRadius: 8,
    justifyContent: "center",
    alignItems: "center"},
  webButtonText: {
    color: "#fff",
    fontSize: 18,
    //fontWeight: "600",
    fontFamily: fonts.medium},
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 20},
  modalContainer: {
    backgroundColor: "white",
    borderRadius: 12,
    padding: 24,
    width: "100%",
    maxWidth: 400,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 8},
  modalTitle: {
    fontSize: 20,
    //fontWeight: "700",
    marginBottom: 12,
    textAlign: "center",
    color: "#1A1A1A",
    fontFamily: fonts.regular
  },
  modalText: {
    fontSize: 16,
    lineHeight: 22,
    color: "#444",
    textAlign: "center",
    marginBottom: 24,
    fontFamily: fonts.regular
  },
  modalButtons: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 12},
  cancelBtn: {
    backgroundColor: "#E0E0E0",
    paddingVertical: 10,
    paddingHorizontal: 22,
    borderRadius: 6},
  continueBtn: {
    backgroundColor: "#3629B7",
    paddingVertical: 10,
    paddingHorizontal: 22,
    borderRadius: 6},
  cancelText: {
    color: "#000",
    //fontWeight: "600",
    fontSize: 15,
    fontFamily: fonts.medium},
  continueText: {
    color: "#fff",
    //fontWeight: "600",
    fontSize: 15,
    fontFamily: fonts.medium
  }});
